export const SET_REGION = "SET_REGION";

export function setRegion(region, prevRegion) {
  return {
    type: SET_REGION,
    region,
    prevRegion
  };
}
